var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrizeMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconPrizeMachine_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 282",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h112v112H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconPrizeMachine_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 457",
    fill: "none",
    d: "M0 0h112v112H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconPrizeMachine_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 453",
    fill: "none",
    d: "M0 0h30.965v30.965H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconPrizeMachine_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "IconPrizeMachine",
    clipPath: "url(#IconPrizeMachine_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 452",
    fill: "#040000",
    d: "M54.833 14.597h2.333v88.121h-2.333z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 420"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 752",
    d: "M9.333 102.718H56V69.36H9.333zm38.738-12.185a.933.933 0 01-.933.933H18.82a.936.936 0 01-.933-.933V77.691a.936.936 0 01.933-.933h28.313a.933.933 0 01.933.933z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 753",
    d: "M56.117 102.718h46.662V69.36H56.116zm38.229-12.185a.936.936 0 01-.933.933H65.095a.933.933 0 01-.933-.933V77.691a.933.933 0 01.933-.933h28.318a.936.936 0 01.933.933z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 754",
    d: "M102.666 16.126H9.333v-5.86a.934.934 0 01.933-.933h91.467a.934.934 0 01.933.933z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 755",
    d: "M9.389 69.798h93.333v-54.74H9.389zm2.333-52.406h88.667v50.073H11.722z",
    fill: "#231815"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 421",
    transform: "translate(67.501 16.934)",
    clipPath: "url(#IconPrizeMachine_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 756",
    d: "M5.199 18.668l5.007 8.674-.268.154-3.22-1.5-4.137-7.166.426-1.608 5.694-3.288 2.553-1.471a4.158 4.158 0 00-.037.556 4.226 4.226 0 00.048.634c.012.082.027.163.044.244l.027.122c.019.08.04.159.064.237l.037.118a4.078 4.078 0 00.234.559l-2.5 1.444z",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 757",
    d: "M16.173 12.334l-.491.282-.2.116-.511.3-.34.2-.038.022-1.625.939a2.774 2.774 0 01-.257-1.166 2.719 2.719 0 01.189-1.005c.035-.088.074-.173.115-.254a2.777 2.777 0 01.337-.508l1.2-.7.075-.043.371-.214.48.836.268.464.28.485z",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 758",
    d: "M18.257 13.019a2.761 2.761 0 01-.259 1.168l-1.627-.94-.037-.022-.341-.2-.512-.3-.2-.116-.492-.282.145-.252.28-.485.267-.464.485-.836.368.213.075.042 1.206.7a2.8 2.8 0 01.337.508 2.413 2.413 0 01.115.254 2.749 2.749 0 01.191 1.005",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 759",
    d: "M28.385 18.829l-4.138 7.166-3.22 1.5-.268-.154 5.007-8.674-3.97-2.288-2.5-1.444a4.169 4.169 0 00.245-.588c.021-.06.039-.119.056-.18a4.25 4.25 0 00.157-1.146 3.815 3.815 0 00-.041-.559l2.555 1.477 5.69 3.285z",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 760",
    d: "M18.257 13.019a2.761 2.761 0 01-.259 1.168l-.01.023-.005.014a2.778 2.778 0 01-5 0l-.005-.014-.01-.025a2.774 2.774 0 01-.257-1.166 2.719 2.719 0 01.189-1.005c.035-.088.074-.173.115-.254a2.777 2.777 0 01.337-.508 2.737 2.737 0 011.2-.84c.054-.021.108-.037.164-.053l.053-.016a2.736 2.736 0 011.421 0l.054.016c.056.015.11.032.162.051a2.74 2.74 0 011.206.841 2.8 2.8 0 01.337.508 2.415 2.415 0 01.115.254 2.749 2.749 0 01.191 1.005",
    fill: "#070102"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 761",
    d: "M11.214 13.141z",
    fill: "#070102"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 762",
    d: "M11.214 13.141h0z",
    fill: "none",
    stroke: "#060001",
    strokeMiterlimit: 10,
    strokeWidth: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 763",
    d: "M16.433 7.018l-.078-.011a6.906 6.906 0 00-1.744 0l-.08.011a6.975 6.975 0 00-6 6.888v.029a6.941 6.941 0 00.467 2.473l.012.035a6.993 6.993 0 001.8 2.6l.049.044h9.252l.049-.045a6.959 6.959 0 001.794-2.6l.011-.032a6.826 6.826 0 00.472-2.474v-.031a6.976 6.976 0 00-6-6.888m-5.049 6c0-.085 0-.173.01-.268s.015-.179.026-.266v-.009A4.116 4.116 0 0114.6 9.016l.064-.014a4.125 4.125 0 011.647 0l.062.014a4.11 4.11 0 013.171 3.468 3.613 3.613 0 01.039.534 4.085 4.085 0 01-.151 1.1 3.031 3.031 0 01-.053.171 3.961 3.961 0 01-.235.564l-.019.038a4.1 4.1 0 01-7.286 0l-.019-.038a3.909 3.909 0 01-.224-.535l-.035-.112c-.022-.076-.044-.152-.062-.227l-.026-.119a4.467 4.467 0 01-.042-.236l-.02-.147-.012-.121-.006-.056v-.283",
    fill: "#060001"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 422"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 454",
    fill: "#231815",
    d: "M80.772 15.501h4.424v8.847h-4.424z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 423",
    transform: "translate(13.533 16.934)",
    clipPath: "url(#IconPrizeMachine_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 764",
    d: "M5.201 18.668l5.007 8.674-.268.154-3.22-1.5-4.14-7.167.426-1.608 5.695-3.287 2.55-1.471a4.158 4.158 0 00-.037.556 4.226 4.226 0 00.048.634c.012.082.027.163.044.244l.027.122c.019.08.04.159.064.237l.037.118a4.078 4.078 0 00.234.559l-2.5 1.444z",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 765",
    d: "M16.174 12.334l-.492.282-.2.116-.511.3-.34.2-.038.022-1.625.939a2.774 2.774 0 01-.257-1.166 2.719 2.719 0 01.189-1.005c.035-.088.074-.173.115-.254a2.774 2.774 0 01.337-.508l1.2-.7.075-.043.371-.214.48.836.268.464.28.485z",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 766",
    d: "M18.257 13.02a2.761 2.761 0 01-.259 1.168l-1.627-.94-.037-.022-.341-.2-.512-.3-.2-.116-.496-.276.145-.252.28-.485.267-.464.485-.836.368.213.075.042 1.206.7a2.8 2.8 0 01.337.508 2.412 2.412 0 01.115.254 2.749 2.749 0 01.191 1.005",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 767",
    d: "M28.385 18.829l-4.142 7.166-3.22 1.5-.268-.154 5.007-8.674-3.971-2.289-2.5-1.444a4.165 4.165 0 00.245-.588c.021-.06.039-.119.056-.18a4.25 4.25 0 00.157-1.146 3.808 3.808 0 00-.041-.559l2.555 1.476 5.69 3.285z",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 768",
    d: "M18.257 13.019a2.761 2.761 0 01-.259 1.168l-.01.023-.005.014a2.778 2.778 0 01-5 0l-.009-.014-.01-.025a2.774 2.774 0 01-.257-1.166 2.719 2.719 0 01.191-1.009c.035-.088.074-.173.115-.254a2.776 2.776 0 01.337-.508 2.737 2.737 0 011.2-.84c.054-.021.108-.037.164-.053l.053-.016a2.736 2.736 0 011.421 0l.054.016c.056.015.11.032.162.051a2.74 2.74 0 011.206.841 2.8 2.8 0 01.337.508 2.413 2.413 0 01.115.254 2.749 2.749 0 01.191 1.005",
    fill: "#070102"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 769",
    d: "M11.216 13.141z",
    fill: "#070102"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 770",
    d: "M11.216 13.141h0z",
    fill: "none",
    stroke: "#060001",
    strokeMiterlimit: 10,
    strokeWidth: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 771",
    d: "M16.438 7.018l-.078-.011a6.906 6.906 0 00-1.744 0l-.08.011a6.975 6.975 0 00-6 6.888v.029a6.941 6.941 0 00.467 2.473l.012.035a6.993 6.993 0 001.8 2.6l.049.044h9.256l.049-.045a6.959 6.959 0 001.794-2.6l.011-.032a6.826 6.826 0 00.464-2.473v-.031a6.976 6.976 0 00-6-6.888m-5.049 6c0-.085 0-.173.01-.268s.015-.179.026-.266v-.01a4.116 4.116 0 013.173-3.458l.064-.014a4.125 4.125 0 011.647 0l.062.014a4.11 4.11 0 013.167 3.47 3.615 3.615 0 01.039.534 4.087 4.087 0 01-.151 1.1 3.031 3.031 0 01-.053.171 3.961 3.961 0 01-.235.564l-.019.038a4.1 4.1 0 01-7.286 0l-.019-.038a3.913 3.913 0 01-.224-.535l-.035-.112c-.022-.076-.044-.152-.062-.227l-.026-.119a4.467 4.467 0 01-.042-.236l-.02-.147-.012-.121-.005-.055v-.283",
    fill: "#060001"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 456",
    fill: "#231815",
    d: "M26.804 15.501h4.424v8.847h-4.424z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrizeMachine);
export default __webpack_public_path__ + "static/media/IconPrizeMachine.07cd9ca33614688e.svg";
export { ForwardRef as ReactComponent };